// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mW7l","questions":"styles_questions__1pjgp","footer":"styles_footer__QQQO5"};